import React, { useEffect, useState } from "react";
import AccountLayoutWeb from "./AccountLayoutWeb";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import moment from "moment";
import CustomPagination from "./CustomPagination";
const Activitylog = () => {
  const [loader, setLoader] = useState(false);
  const [getLogData, setLogData] = useState({});
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 10,
  });
  const [pagination, setPagination] = useState({
    page: 0,
    totalPages: 0,
    hasPrevPage: false,
    hasNextPage: false,
  });
  const myLogData = async (page) => {
    setLoader(true);
    const { status, data: response_users } = await apiGet(
      apiPath.activityLogs,
      { ...search_params, page: page > 0 ? page : search_params?.page }
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
        setPagination({
          page: response_users?.results?.page,
          totalPages: response_users?.results?.totalPages,
          hasPrevPage: response_users?.results?.hasPrevPage,
          hasNextPage: response_users?.results?.hasNextPage,
        });
      } else {
        setPagination({
          page: 1,
          totalPages: 0,
          hasPrevPage: false,
          hasNextPage: false,
        });
      }
    }
    setLoader(false);
  };
  useEffect(() => {
    myLogData();
  }, []);
  const handlePageChange = (newPage) => {
    myLogData(newPage);
  };
  return (
    <AccountLayoutWeb>
      <div className="col-center report">
        <h2>Activity Log</h2>{" "}
        <table className="table-s" id="Matched_Table">
          <tbody>
            <tr>
              <th scope="col" className="text-left">
                Login Date & Time
              </th>
              <th scope="col" className="text-end">
                Login Status
              </th>
              <th scope="col" className="text-end">
                IP Address
              </th>
              <th scope="col" className="text-end">
                ISP
              </th>
              <th scope="col" className="text-end">
                City/State/Country
              </th>
              <th scope="col" className="text-end">
                User Agent Type
              </th>
            </tr>
          </tbody>

          {getLogData.data?.length > 0 ? (
            <tbody id="Matched_Content">
              {getLogData.data &&
                getLogData.data.map((item, key) => (
                  <tr key={key}>
                    <td style={{ textAlign: "left" }}>
                      {moment(item?.activityDate).format("YYYY-MM-DD hh:mm:ss")}
                    </td>
                    <td>
                      {" "}
                      <span style={{ color: "#508d0e" }} className="text-end">
                        {item.activityStatus}
                      </span>
                    </td>
                    <td className="text-end">{item.ip || "-"}</td>
                    <td className="text-end">{item.isp || "-"}</td>
                    <td className="text-end">{item.region || "-"}</td>
                    <td className="text-end w-25">{item.userAgent || "-"}</td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tbody id="Matched_Content">
              <tr
                id="noDataTemplate"
                style={{
                  display: "table-row",
                }}
              >
                <td className="no-data" colSpan="9">
                  <p>You have no bets in this time period.</p>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>{" "}
      {pagination?.page > 0 && (
        <CustomPagination
          pagination={pagination}
          onPageChange={handlePageChange}
        />
      )}
    </AccountLayoutWeb>
  );
};

export default Activitylog;
